import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";
import { Tooltip, AlertIcon } from "@td/ui";
import classNames from "classnames";
import { translate } from "@td/shared_utils";
import moment from "moment-timezone";
import { SERVER_DATE_FORMAT } from "../../../../constants";

const DueDate = React.memo(({ task }) => {
  const { dueDate } = task;

  const isPastDue = useMemo(() => moment().isAfter(moment(dueDate, SERVER_DATE_FORMAT)), [dueDate]);
  const convertedDueDate = useMemo(() => moment.tz(dueDate, SERVER_DATE_FORMAT, window.APP_TIMEZONE), [dueDate]);
  const tooltipTitle = useMemo(() => {
    return isPastDue
      ? translate(null, "care_team_tasks.list_view.tooltips", "past_due")
      : null;
  }, [isPastDue]);

  return (
    <Tooltip title={tooltipTitle}>
      <div
        className={classNames(styles.dueDate, {
          [styles.alert]: isPastDue,
        })}
      >
        {convertedDueDate.format("DD-MMM-YYYY")}

        {isPastDue && (
          <div className={styles.alertIcon}>
            <AlertIcon
              width={14}
              height={14}
              fill="#C9311A"
            />
          </div>
        )}
      </div>
    </Tooltip>
  );
});

DueDate.propTypes = {
  task: PropTypes.shape({
    dueDate: PropTypes.string.isRequired,
  }),
};

export default DueDate;
